<template>
    <div>
        <!-- Bandejas diferentes de Tesorero-->
        <div>
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Bandeja de solicitudes rechazadas</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-toolbar flat color="white">
                <v-divider ></v-divider>
            </v-toolbar>
            <!-- Bandejas de supervisor y financiero -->
            <v-tabs fixed-tabs  v-model="tabs"> 
                <!-- Tabs de la pagina -->
                <v-tab>Individuales</v-tab>
                <v-tab>Grupos</v-tab>
                <!-- Contenido de las Tabs -->
                <!-- Tab de Solicitudes -->
                <v-tab-item>
                    <v-data-table :headers="headers" :items="solicitudes" :search="searchSolicitud" class="elevation-1" v-model="selected_solicitudes" item-key="id_solicitud">
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="searchSolicitud" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus" v-model="alerta_estatus">Estatus cambiado exitosamente</v-alert>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_edicion" v-model="alerta_edicion">Solicitud editada exitosamente</v-alert>

                        </template>
                        <template v-slot:item.actions="{ item }">

                            <div v-if="user.nivel_acceso === 'tesorero' || user.nivel_acceso === 'financiero'"  class="text-truncate">
                                <v-icon v-if="user.nivel_acceso == 'financiero'" small class="mr-1" @click="show_update_dialog(item)">mdi-credit-card-check</v-icon>
                                <v-icon v-if="user.nivel_acceso === 'tesorero'" small class="mr-1" @click="send_finance(item)">mdi-arrow-expand-right</v-icon>
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                            <div v-else>
                                
                                <v-icon small class="mr-1" @click="show_details_dialog(item)">mdi-eye</v-icon>
                                <v-icon small class="mr-1" @click="show_log_solicitud(item)">mdi-playlist-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <!-- Tab de Grupos -->
                <v-tab-item>
                    <v-data-table :headers="headers_grupos" :items="grupos" :search="search_grupos" class="elevation-1"  item-key="id_grupo" v-model="selected_grupos">
                        <template v-slot:top>
                            <v-row justify="center">
                                <v-col cols="10" sm="10" md="10">
                                    <v-text-field v-model="search_grupos" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert dense text type="success" dismissible close-icon="mdi-delete" v-if="alerta_estatus_grupos" v-model="alerta_estatus_grupos">Estatus cambiado exitosamente</v-alert>
                           
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-icon v-if="user.nivel_acceso=='tesorero'" class="mr-1" small @click="send_finance(item)">mdi-arrow-expand-right</v-icon>
                            <v-icon small @click="show_dialog_details_grupos(item)">mdi-eye</v-icon>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs>
        </div>
     
        <!-- POPUPS -->
        <!-- Solicitudes de un grupo -->
  
        <!-- Autorizar solicitud -->
        <!-- Autorizar solicitud -->
        <v-dialog v-model="dialog_autorizar_solicitud" max-width="590">
            <v-card>
              <v-card-title
                ><span class="headline">Cambiar Estatus Solicitud</span></v-card-title
              >
              <v-card-text>
                <v-form ref="autorizar_solicitud_ref">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-select
                        v-if="
                          user.nivel_acceso === 'supervisor' ||
                          user.nivel_acceso === 'director financiero' ||
                          user.nivel_acceso === 'director general'
                        "
                        v-model="estado_autorizar"
                        :items="estados"
                        item-value="id_estatus"
                        item-text="estatus"
                        label="Estatus autorización"
                        data-vv-name="select"
                        :rules="[(v) => !!v || 'Seleccione un tipo de solicitud']"
                        required
                      ></v-select>
                      <v-select
                        v-if="user.nivel_acceso === 'financiero'"
                        v-model="estado_autorizar"
                        :items="estados"
                        item-value="id_estatus"
                        item-text="estatus"
                        label="Estatus autorización"
                        data-vv-name="select"
                        :rules="[(v) => !!v || 'Seleccione un tipo de solicitud']"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-if="
                          user.nivel_acceso === 'supervisor' ||
                          user.nivel_acceso === 'director financiero' ||
                          user.nivel_acceso === 'director general'
                        "
                        v-model="selected_solicitud.anotaciones"
                        label="Anotaciones"
                        value="selected_solicitud.anotaciones"
                        required
                      ></v-textarea>
                      <v-textarea
                        v-if="user.nivel_acceso === 'financiero'"
                        v-model="selected_solicitud.anotaciones_financiero"
                        label="Anotaciones"
                        value="selected_solicitud.anotaciones_financiero"
                        required
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog_autorizar_solicitud = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="autorizar_solicitud()"
                  :disabled="is_waiting"
                >
                  <label v-if="!is_waiting">Confirmar</label>
                  <v-progress-circular
                    small
                    indeterminate
                    color="primary"
                    v-if="is_waiting"
                    :size="20"
                  ></v-progress-circular
                ></v-btn>
              </v-card-actions>
            </v-card>
      </v-dialog>
<!-- Solicitudes de un grupo -->
    <v-dialog v-model="dialog_solicitudes_grupo">
      <v-card>
        <v-card-title
          ><span class="headline">Solicitudes de Grupo</span></v-card-title
        >
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="solicitudes_grupo"
            :search="search_solicitudes_grupo"
            class="elevation-1"
            v-model="selected_solicitudes_grupo"
            show-select
            item-key="id_solicitud"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title style="color: #1C2546; margin-top: 40px"
                  >Autorización de gastos</v-toolbar-title
                >
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  style="margin-top: 30px"
                ></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row justify="center">
                <v-col cols="10" sm="10" md="10">
                  <v-text-field
                    v-model="search_solicitudes_grupo"
                    append-icon="mdi-magnify"
                    label="Buscar"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-alert
                dense
                text
                type="success"
                dismissible
                close-icon="mdi-delete"
                v-if="alerta_estatus_grupo"
                v-model="alerta_estatus_grupo"
                >Estatus cambiado exitosamente</v-alert
              >
              <v-alert
                dense
                text
                type="success"
                dismissible
                close-icon="mdi-delete"
                v-if="alerta_edicion_grupo"
                v-model="alerta_edicion_grupo"
                >Solicitud editada exitosamente</v-alert
              >
 
              <div style="margin-top: 35px">
                <v-btn class="ma-2" color="primary" @click="refresh"
                  >Actualizar</v-btn
                >
                <v-btn
                  v-if="user.nivel_acceso === 'financiero'"
                  class="ma-2"
                  tile
                  outlined
                  color="primary"
                  @click="show_dialog_autorizar_solicitudes"
                  ><v-icon left>mdi-credit-card-check</v-icon> Cambiar estatus
                  de varias solicitudes
                </v-btn>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div
                v-if="user.nivel_acceso === 'tesorero'"
                class="text-truncate"
              >
                <v-icon small @click="show_details_dialog(item)"
                  >mdi-eye</v-icon
                >
                <v-icon small class="mr-1" @click="show_log_solicitud(item)"
                  >mdi-playlist-check</v-icon
                >
              </div>
              <div
                v-if="
                  user.nivel_acceso === 'supervisor' ||
                  user.nivel_acceso === 'financiero' ||
                  user.nivel_acceso === 'director financiero' ||
                  user.nivel_acceso === 'director general'
                "
                class="text-truncate"
              >
                <v-icon
                  :disabled="validate_item(item)"
                  small
                  class="mr-1"
                  @click="show_update_dialog(item)"
                >
                  mdi-credit-card-check
                </v-icon>
                <v-icon
                  :disabled="validate_item(item)"
                  small
                  class="mr-1"
                  @click="show_edit_dialog(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small class="mr-1" @click="show_details_dialog(item)"
                  >mdi-eye</v-icon
                >
                <v-icon small class="mr-1" @click="show_log_solicitud(item)"
                  >mdi-playlist-check</v-icon
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
        <!-- Autorizar muchas solicitudes -->
        <v-dialog v-model="dialog_autorizar_solicitudes" max-width="590" >
            <v-card>
                <v-card-title><span class="headline">Autorizar Comprobaciones</span></v-card-title>
                <v-card-text>
                    <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_error_multiples" v-model="alerta_error_multiples">Se debe seleccionar al menos 1 solicitud pendiente de revisión.</v-alert>
                    <v-form ref="autorizar_solicitudes_ref">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-select v-model="estado_autorizar_multiple" :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea  v-model="anotaciones_multiples" label="Anotaciones" value=""></v-textarea>
                            </v-col>  
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_autorizar_solicitudes = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="autorizar_multiples_solicitudes()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Autorizar muchos grupos -->
        <v-dialog v-model="dialog_autorizar_grupos" max-width="590" >
            <v-card>
                <v-card-title><span class="headline">Autorizar Grupos</span></v-card-title>
                <v-card-text>
                    <v-alert dense text type="error" dismissible close-icon="mdi-delete" v-if="alerta_error_multiples_grupos" v-model="alerta_error_multiples_grupos">Se debe seleccionar al menos 1 grupo con al menos 1 solicitud pendiente de revisión.</v-alert>
                    <v-form ref="autorizar_grupos_ref">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-select v-model="estado_autorizar_multiple" :items="estados" item-value="id_estatus" item-text="estatus" label="Estatus autorización" data-vv-name="select" :rules="[v => !!v || 'Seleccione un tipo de solicitud']" required></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea  v-model="anotaciones_multiples" label="Anotaciones" value=""></v-textarea>
                            </v-col>  
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_autorizar_grupos = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="autorizar_multiples_grupos()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                </v-card-actions>
            </v-card>     
        </v-dialog>
        <!-- Mostrar Solicitud -->
        <v-dialog v-model="dialog_show_solicitud" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Detalles de solicitud</span></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Fecha de solicitud:</strong><br/> {{selected_solicitud.fecha_modified}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Nombre solicitante:</strong><br/> {{selected_solicitud.nombre}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Tipo Gasto:</strong><br/> {{selected_solicitud.nombre_cuenta}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Divisa:</strong><br/> {{selected_solicitud.divisa}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Archivo Presentado:</strong><br/> {{selected_solicitud.tipo_archivo_solicitud}}</p>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <p><strong>Tipo de Gasto:</strong><br/> {{selected_solicitud.locacion_solicitud}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Subtotal:</strong><br/> {{selected_solicitud.subtotal_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>IVA:</strong><br/> {{selected_solicitud.iva_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Total:</strong><br/> {{selected_solicitud.importe_modified}}</p>
                        </v-col>
                        <v-col cols="3" sm="3" md="3">
                            <p><strong>Total (Cambio de divisa):</strong><br/> {{selected_solicitud.importe_cambio}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina">
                            <p><strong>Propina:</strong><br/> {{selected_solicitud.propina}}</p>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina_details">
                            <p><strong>Descripción Propina:</strong><br/> {{selected_solicitud.descripcion_propina}}</p>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="show_propina_details">
                            <p><strong>Comensales Propina:</strong><br/> {{selected_solicitud.comensales_propina}}</p>
                        </v-col>
                    </v-row>
                    <v-row v-if="requiere_descripcion">
                        <v-col cols="12" sm="12" md="12">
                            <p><strong>Comentarios:</strong><br/> {{selected_solicitud.comentarios}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <p><strong>Descripción:</strong><br/> {{selected_solicitud.descripcion}}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <strong>Comprobantes</strong> <br />
                            <v-data-table :headers="fileHeaders" :items="archivos_solicitud" class="elevation-1"> 
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-1" @click="download_file(item)">mdi-download</v-icon>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialog_show_solicitud = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card> 
        </v-dialog>

        <!-- Historial de la Solicitud -->
        <v-dialog v-model="dialog_log_solicitud" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Historial de solicitud</span></v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers_log" :items="log_solicitud" class="elevation-1"></v-data-table>
                </v-card-text>
                <v-card-text>
                    <v-data-table :headers="[{'text': 'Supervisor','value':'anotaciones'},{'text': 'Financiero','value':'anotaciones_financiero'}]" :items="log_comment" class="elevation-1">
                    </v-data-table>
                </v-card-text>
            </v-card> 
        </v-dialog>

        <!-- Envio de Comprobaciones al financiero-->
        <v-dialog v-model="dialog_envio" max-width="60%">
            <v-card>
                <v-card-title><span class="headline">Enviar Comprobación a financiero</span></v-card-title>
                <v-divider></v-divider>
                <div class="pl-4 bolder">Confirmar envio a bandeja financiero</div>
                <v-divider></v-divider>
                <v-card-text>
                  <v-btn title  rounded color="red darken-1" @click="dialog_envio = false; selected_to_send=null" text class="mr-2" >Cancelar</v-btn>
                  <v-btn title  rounded color="green darken-1" @click="finance()" text >Aceptar</v-btn>
                </v-card-text>
      
            </v-card> 
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios'


export default {
    data: function (){
        return {
          tabs: 0,
          headers: [
            {text: "Fecha de Comprobación", value:"fecha_modified"},
            {text: "Deudor",value: "nombre"},
            {text: "Cuenta", value: "nombre_cuenta" },
            {text: "Divisa", value: "divisa", sortable: true },
            {text: "Importe", value: "importe_modified" },
            {text: "Estatus de Supervisor", value: "estatus", sortable: true },
            {text: "Estatus de Financiero", value: "estatus_financiero", sortable: true },
            {text: "Acciones", value: "actions", sortable: false }
          ],solicitudes: [],
          solicitudes_grupo: [],
          searchSolicitud: "",
          search_solicitudes_grupo: "",
          selected_solicitudes: [],
          selected_solicitudes_grupo: [],
          selected_solicitud: {},
          selected_to_send: null,
          alerta_estatus: false,
          alerta_solicitud: false,
          alerta_estatus_grupos: false,
          alerta_estatus_grupo: false,
          alerta_edicion_grupo: false,
          log_comment: [],
          headers_grupos: [
          { text: "Nombre del grupo", value: "nombre" },
          { text: "Creador", value: "nombre_creador" },
          { text: "Nombre Grupo", value: "nombre" },
          { text: "Descripción", value: "descripcion" },
          { text: "Monto total", value: "monto_total" },
          { text: "Solicitudes Totales", value: "solicitudes_totales" },
          { text: "Solicitudes en proceso", value: "num_pendientes" },
          {
          text: "Solicitudes aprobadas totalmente",
          value: "num_aprobadas",
          sortable: true,
          },
          {
          text: "Solicitudes rechazadas (total o parcial)",
          value: "num_rechazadas",
          sortable: true,
          },
          { text: "Acciones", value: "actions", sortable: false },
          ],
          selected_grupos: [],
          grupos: [],
          search_grupos: "",
          estados: [{id_estatus: 2,estatus: 'Aprobado'}],
          mostrar_cargar: false,
          headers_log: [],
          alerta_error_multiples: false,
          estado_autorizar_multiple: null,
          dialog_autorizar_grupos: false,
          dialog_envio: false,
          anotaciones_multiples: "",
          alerta_edicion: false,
          log_solicitud: false,

          dialog_log_solicitud: false,
          is_waiting: false,
          alerta_error_multiples_grupos: false,
          dialog_solicitudes_grupo: false,
          dialog_show_solicitud: false,
          requiere_descripcion: false,
          fileHeaders: [],
          archivos_solicitud: null,
          dialog_autorizar_solicitudes: false,
          dialog_autorizar_solicitud: false,
          estado_autorizar: "",
          solicitud_raw: {},
          deudor: {}
        }
    },
    methods: {
      validate_item(item) {
      var nivel_acceso = this.$store.state.user.nivel_acceso;
      if (nivel_acceso === "supervisor") {
        if (item.es_delegado === "Sí") {
          if (item.id_estatus === "1") {
            return false;
          } else {
            return true;
          }
        } else {
          if (item.id_estatus === "1") {
            return false;
          } else {
            return true;
          }
        }
      } else if (nivel_acceso === "director general") {
        if (item.es_delegado === "Sí") {
          if (item.id_estatus === "1") {
            return false;
          } else if (item.id_estatus_financiero === "1") {
            return false;
          } else {
            return true;
          }
        } else {
          if (item.id_estatus === "1") {
            return false;
          } else {
            return true;
          }
        }
      } else if (nivel_acceso === "financiero") {
        if (item.es_delegado === "Sí") {
          if (item.id_estatus === "1") {
            return false;
          } else if (item.id_estatus_financiero === "1") {
            return false;
          } else {
            return true;
          }
        } else {
          if (item.es_acargo) {
            if (item.id_estatus === "1") {
              return false;
            } else {
              return true;
            }
          } else {
            if (item.id_estatus_financiero === "1") {
              return false;
            } else {
              return true;
            }
          }
        }
      }
    },
    map_solicitud_array_loop(solicitud) {
      var solicitud_tmp = {};
      solicitud_tmp["id_solicitud"] = solicitud.id_solicitud;
      solicitud_tmp["id_divisa"] = solicitud.id_divisa;
      solicitud_tmp["id_cuenta"] = solicitud.id_cuenta;
      solicitud_tmp["id_deudor"] = solicitud.id_deudor;
      solicitud_tmp["subtotal"] = solicitud.subtotal;
      solicitud_tmp["iva"] = solicitud.iva;
      solicitud_tmp["total"] = solicitud.total;
      solicitud_tmp["descripcion"] = solicitud.descripcion;
      solicitud_tmp["monto_cambio"] = solicitud.monto_cambio;
      solicitud_tmp["descripcion_propina"] = solicitud.descripcion_propina;
      solicitud_tmp["comensales_propina"] = solicitud.comensales_propina;
      solicitud_tmp["propina"] = solicitud.propina;
      solicitud_tmp["id_estatus"] = solicitud.id_estatus;
      solicitud_tmp["id_estatus_financiero"] = solicitud.id_estatus_financiero;
      solicitud_tmp["anotaciones"] = solicitud.anotaciones;
      solicitud_tmp["anotaciones_financiero"] =
        solicitud.anotaciones_financiero;
      return solicitud_tmp;
    },
      map_solicitud_array(solicitud) {
      this.solicitud_raw["id_solicitud"] = solicitud.id_solicitud;
      this.solicitud_raw["id_divisa"] = solicitud.id_divisa;
      this.solicitud_raw["id_cuenta"] = solicitud.id_cuenta;
      this.solicitud_raw["id_deudor"] = solicitud.id_deudor;
      this.solicitud_raw["subtotal"] = solicitud.subtotal;
      this.solicitud_raw["iva"] = solicitud.iva;
      this.solicitud_raw["total"] = solicitud.total;
      this.solicitud_raw["descripcion"] = solicitud.descripcion;
      this.solicitud_raw["monto_cambio"] = solicitud.monto_cambio;
      this.solicitud_raw["descripcion_propina"] = solicitud.descripcion_propina;
      this.solicitud_raw["comensales_propina"] = solicitud.comensales_propina;
      this.solicitud_raw["propina"] = solicitud.propina;
      this.solicitud_raw["id_estatus"] = solicitud.id_estatus;
      this.solicitud_raw["id_estatus_financiero"] =
        solicitud.id_estatus_financiero;
      this.solicitud_raw["anotaciones"] = solicitud.anotaciones;
      this.solicitud_raw["anotaciones_financiero"] =
        solicitud.anotaciones_financiero;
    },
    autorizar_solicitud: async function (){
            this.is_waiting = true;
      this.alerta_estatus = false;
      let IdGrupo = 0;
      if (this.tabs == 1) {
        IdGrupo = this.total_grupo_selec;
      }
      if (this.$refs.autorizar_solicitud_ref.validate()) {
        this.map_solicitud_array(this.selected_solicitud);
        var nivel_acceso = this.$store.state.user.nivel_acceso;
        if (nivel_acceso === "financiero") {
          this.solicitud_raw["es_delegado"] =
            this.selected_solicitud.es_delegado;
          this.solicitud_raw["es_acargo"] = this.selected_solicitud.es_acargo;
        }
        let browser = this.get_browser();
        var req = {
          solicitud: this.solicitud_raw,
          status: this.estado_autorizar,
          grupo: IdGrupo,
          total_solicitudes: this.total_sol_grupo,
          explorador: navigator.userAgent,
          deudor: { id: this.id_deudor, nombre: this.deudor },
          navigator: browser,
        };
       
        try {
         await  axios
            .put(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/solicitudes/autorizar",
              req
            )
              this.get_solicitudes();
              this.get_grupos();
              if (this.dialog_solicitudes_grupo === true) {
                this.refresh_solicitudes_by_grupo();
              }
              this.is_waiting = false;
              this.dialog_autorizar_solicitud = false;
              this.alerta_estatus = true;
            
        } catch (error) {
          this.is_waiting = false;
          
        }
      }
    },
        show_details_dialog: function (data){
            this.selected_solicitud = Object.assign({}, data);
            this.selected_solicitud.descripcion_propina =
            this.selected_solicitud.descripcion_propina === "undefined"? null: this.selected_solicitud.descripcion_propina;
            this.selected_solicitud.comensales_propina =this.selected_solicitud.comensales_propina === "undefined"? null: this.selected_solicitud.comensales_propina;
            axios
            .get(
            "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/archivos/" +
            this.selected_solicitud.id_solicitud
            )
            .then((res) => {
            this.archivos_solicitud = res.data;
            this.dialog_show_solicitud = true;
            });
            if (this.selected_solicitud.propina != "0") {
            this.show_propina = true;
            }
            if (
            this.selected_solicitud.descripcion_propina !== "" &&
            this.selected_solicitud.descripcion_propina !== null
            ) {
            this.show_propina_details = true;
            } else {
            this.show_propina_details = false;
            }
        },
        show_log_solicitud: function (data){
            this.selected_solicitud = Object.assign({}, data);
            axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/historial/" +
            data.id_solicitud
        )
        .then((res) => {
          this.log_solicitud = res.data.body;
          this.log_comment= res.data.comments
          this.dialog_log_solicitud = true;
        });
        },
        show_propina: function () {

        },
        show_propina_details: function (){

        },
        get_solicitudes:  function (){
            try {
                axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/rechazadas").then( (resp) => {
                  this.solicitudes=resp.data 
                })
                   
            } catch (error) {
                this.solicitudes=[]
            }
            
        },show_dialog_details_grupos(item) {
          this.selected_grupo = item;
          axios
            .get(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/solicitudes/grupo/" +
                item.id_grupo
            )
            .then((res) => {
              this.solicitudes_grupo = res.data;
              this.total_sol_grupo = this.solicitudes_grupo.length;
              this.total_grupo_selec = item.id_grupo;
              this.dialog_solicitudes_grupo = true;
            });
    },
        show_update_dialog(data) {

            this.selected_solicitud = data;
        //     axios
        // .get(
        //   "https://" +
        //     process.env.VUE_APP_URL +
        //     ":3000/gastos/api/v1/catalogos/estatus"
        // )
        // .then((res) => {
        //   this.estados = res.data;
        // });
            this.dialog_autorizar_solicitud = true;
            if (this.$refs.autorizar_solicitud_ref) {
            this.$refs.autorizar_solicitud_ref.reset();
            }
    },
    show_dialog_autorizar_solicitudes() {
      this.alerta_error_multiples = false;
      // axios
      //   .get(
      //     "https://" +
      //       process.env.VUE_APP_URL +
      //       ":3000/gastos/api/v1/catalogos/estatus"
      //   )
      //   .then((res) => {
      //     this.estados = res.data;
      //   });
      this.dialog_autorizar_solicitudes = true;
      if (this.$refs.autorizar_solicitudes_ref) {
        this.$refs.autorizar_solicitudes_ref.reset();
      }
    },
    autorizar_multiples_solicitudes() {
      let IdGrupo = 0;
      if (this.tabs == 1) IdGrupo = this.selected_solicitudes_grupo[0].id_grupo;
      this.is_waiting = true;
      this.alerta_error_multiples = false;
      var nivel_acceso = this.$store.state.user.nivel_acceso;
      var solicitudes_aprobables = [];
      var solicitudes_seleccionadas =
        this.dialog_solicitudes_grupo === true
          ? this.selected_solicitudes_grupo
          : this.selected_solicitudes;

      if (this.$refs.autorizar_solicitudes_ref.validate()) {
        if (solicitudes_seleccionadas.length > 0) {
          for (let y in solicitudes_seleccionadas) {
            var status =
              nivel_acceso === "financiero"
                ? solicitudes_seleccionadas[y].id_estatus_financiero
                : solicitudes_seleccionadas[y].id_estatus;
            var solicitud_tmp;
            if (nivel_acceso === "financiero") {
              if (
                solicitudes_seleccionadas[y].id_estatus === "3" ||
                solicitudes_seleccionadas[y].id_estatus_financiero === "3"
              ) {
                solicitud_tmp = this.map_solicitud_array_loop(
                  solicitudes_seleccionadas[y]
                );
                solicitud_tmp["es_delegado"] =
                  solicitudes_seleccionadas[y].es_delegado;
                solicitud_tmp["es_acargo"] =
                  solicitudes_seleccionadas[y].es_acargo;
                solicitudes_aprobables.push(solicitud_tmp);
              }
            } else {
              if (status === "3") {
                solicitud_tmp = this.map_solicitud_array_loop(
                  solicitudes_seleccionadas[y]
                );
                nivel_acceso === "financiero"
                  ? (solicitud_tmp["anotaciones"] = this.anotaciones_multiples)
                  : (solicitud_tmp["anotaciones_financiero"] =
                      this.anotaciones_multiples);
                solicitudes_aprobables.push(solicitud_tmp);
              }
            }
          }
          if (solicitudes_aprobables.length > 0) {
            var req = {
              solicitudes: solicitudes_aprobables,
              status: this.estado_autorizar_multiple,
              grupo: IdGrupo,
              total_solicitudes: this.total_sol_grupo,
              bandeja_rechazado: '1'
            };
            try {
              axios
                .post(
                  "https://" +
                    process.env.VUE_APP_URL +
                    ":3000/gastos/api/v1/solicitudes/autorizar/multiples",
                  req
                )
                .then(() => {
                  if (this.dialog_solicitudes_grupo === true) {
                    this.alerta_estatus_grupo = false;
                    this.selected_solicitudes_grupo = [];
                    this.refresh_solicitudes_by_grupo();
                    this.get_grupos();
                    this.alerta_estatus_grupo = true;
                  } else {
                    this.alerta_estatus = false;
                    this.selected_solicitudes = [];
                    this.get_solicitudes();
                    this.alerta_estatus = true;
                  }
                  this.is_waiting = false;
                  this.dialog_autorizar_solicitudes = false;
                });
            } catch (error) {
              this.is_waiting = false;
            }
          } else {
            this.is_waiting = false;
            this.alerta_error_multiples = true;
          }
        } else {
          this.is_waiting = false;
          this.alerta_error_multiples = true;
        }
      }
    },
  async send_finance(item){
      
        
        this.selected_to_send=item
        this.dialog_envio=true
      
    },
    async finance(){
      try {
        if(this.selected_to_send.id_solicitud != undefined) //solicitud
        {
          await axios.post(          
            "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/rechazadas_envio",{solicitud: this.selected_to_send})
            
        }
        else{//grupos
          await axios.post(          
            "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupos/aprobaciones/rechazados_envio",{solicitud: this.selected_to_send})
        }

        this.dialog_envio=false
        this.selected_to_send=null
        
        this.get_solicitudes()
        this.get_grupos()

      } catch (error) {
        this.dialog_envio=false
        this.selected_to_send=null
        
      }
    },
    get_grupos() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupos/aprobaciones/rechazados"
        )
        .then((res) => {
          this.grupos = res.data;
        });
    },
        get_deudor() {
            axios
            .get(
            "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/usuarios/" +
            this.$store.state.token
            )
            .then((res) => {
            this.deudor = res.data.nombre;
            this.id_deudor = res.data.id_user;
            });
        },
        get_browser() {
      let ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
          if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: "IE", version: tem[1] || "" };
          }
          if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);
            if (tem != null) {
              return { name: "Opera", version: tem[1] };
            }
          }
          M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
          if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
          }
          return {
            name: M[0],
            version: M[1],
          };
    },
    refresh_solicitudes_by_grupo() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/solicitudes/grupo/" +
            this.selected_grupo.id_grupo
        )
        .then((res) => {
          this.solicitudes_grupo = res.data;
        });
    },
    refresh: function(){

    }
    },
    computed: {
        user: function () {
            return this.$store.state.user;
        }
    },
    mounted: function (){
        this.get_solicitudes()
        this.get_grupos()
    }
}
</script>